// extracted by mini-css-extract-plugin
module.exports = {"prevNext":"_1_Yvur7lgqYGG8ye_vtP5i","prevNextDisabled":"_1shw1TQAjPwvBvJJ16pIVJ"};